<script setup>

import { KNOLIA } from "@/knolia";
import { ref, onMounted, onUpdated } from "vue";
import { Gems } from "../gems";
import ActivitiesJobRow from "../components/ActivitiesJobRow.vue";

const subordinates = ref([])
const activities = ref([])
const activitiesToAdd = ref([])
const unratedActivities = ref([])
const subordinateActivities = ref([])
const userData = ref([])
const currentSubordinate = ref({ name: null, id: null })




async function GetSubordinateActivities(subordinateName, subordinateId) {
    currentSubordinate.value.name = subordinateName
    currentSubordinate.value.id = subordinateId

    KNOLIA.SetRequestedUserId(subordinateId)

    const response = await KNOLIA.CallBackEnd('post', 'get-subordinate-activities', { params: { user_id: subordinateId } })
    activitiesToAdd.value = response.data.activities_to_add ?? []
    subordinateActivities.value = response.data.user_activities ?? []
    unratedActivities.value = response.data.unrated_activities ?? []
    userData.value = response.data.user_data ?? []
    SetActivitiesAccess()
}

function SetActivitiesAccess() {
    activities.value.forEach(activity => {
        document.getElementById(`activity${activity.id}`).classList.remove('unavailable')
    })

    subordinateActivities.value.forEach(activity => {
        const ind = activities.value.findIndex(elem => elem.id == activity.id)
        activities.value[ind].showChildren = false

        document.getElementById(`activity${activity.id}`).classList.add('unavailable')
    })

    activitiesToAdd.value.forEach(activity => {
        const ind = activities.value.findIndex(elem => elem.id == activity.id)
        activities.value[ind].showChildren = false

        document.getElementById(`activity${activity.id}`).classList.add('unavailable')
    })

    unratedActivities.value.forEach(activity => {
        const ind = activities.value.findIndex(elem => elem.id == activity.id)
        activities.value[ind].showChildren = false

        document.getElementById(`activity${activity.id}`).classList.add('unavailable')
    })
}

async function RemoveActivityFromUser(activity){
    activity.active = false; 
    ControlActivityStatus(activity)
}

async function ControlActivityStatus(activity) {
    await KNOLIA.CallBackEnd('post', 'control-activity-status', { params: { activity } })
    GetSubordinateActivities(currentSubordinate.value.name, currentSubordinate.value.id)
}

async function SelectTaskAssignment(activity, task) {
    if(!activity.active) {
        Gems.Telegram('Habilite a atividade antes', 'tele-not-allowed')
        return;
    }

    await KNOLIA.CallBackEnd('post', 'set-outside-job-task-assignment', { params: { activity, task, currentSubordinate: currentSubordinate.value } })
}

async function SetActivityToUser(event) {
    const activity = JSON.parse(event.dataTransfer.getData('activity'))
    activity.active = true
    activity.is_function_activity = false

    ControlActivityStatus(activity)
}


onMounted(async () => {
    const responseSubordinates = await KNOLIA.CallBackEnd('get', 'get-operations', {
        params: {
            get: 'subordinates'
        }
    })
    subordinates.value = responseSubordinates.data

    const responseActivities = await KNOLIA.CallBackEnd('post', 'get-activities-list')
    activities.value = responseActivities.data
})

onUpdated(() => {
    document.querySelectorAll('.activity-status').forEach(elem => {
        Gems.Tooltip(elem, 'Ativar/Desativar atividade', 'tooltip')
    })
})

</script>

<template>
    <div class="splitter page-container">
        <div id="first" class="top">
            <div id="div-subordinates-container">
                <div id="div-subordinates-title">
                    <h2>Subordinados</h2>
                </div>

                <div class="div-column-container scrollbar">
                    <div class="div-row" :class="{ 'bg-alt-line': currentSubordinate.id == subordinate.user_id }"
                        v-for="subordinate in subordinates" :key="subordinate.user_id"
                        @click="GetSubordinateActivities(subordinate.name, subordinate.user_id)">
                        <span class="line-clamp line-clamp-1" @mouseover="Gems.TooltipIfNeeded($event.target)">{{
                            subordinate.name }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div id="second" class="bottom">
            <div id="div-activity-container">
                <div id="div-activity-title">
                    <h2>Atividades [{{ currentSubordinate.name ?? 'Escolha um subordinado' }}]</h2>
                </div>

                <div class="div-column-container scrollbar">
                    <div v-if="currentSubordinate.id">
                        <li class="job-title">Função: {{ userData?.job_desig }}</li>
                        <div v-for="activity in subordinateActivities" :key="activity.id">
                            <div class="div-row-activity">
                                <i class="fas show-children cursor-pointer"
                                    :class="{ 'fa-chevron-down': !activity.showChildren, 'fa-chevron-up': activity.showChildren }"
                                    @click="activity.showChildren = !activity.showChildren"></i>
                                <label for="">{{ activity.designation }}</label>
                                <input class="activity-status cursor-pointer" type="checkbox" v-model="activity.active"
                                    @change="ControlActivityStatus(activity)">
                            </div>

                            <div class="div-tasks" v-show="activity.showChildren">
                                <div class="div-task-container div-row-activity" v-for="task in activity.children"
                                    :key="task.id">
                                    <div class="div-task line-clamp line-clamp-1"
                                        @mouseover="Gems.TooltipIfNeeded($event.target)">{{ task.designation }}</div>

                                    <select class="cursor-pointer ddl-alt-padding" :class="!draggable ? 'job-task' : ''"
                                        :value="task.selected_assignment" disabled>
                                        <option :value="0"> Não atribuida </option>
                                        <option v-for="assignment in task.assignment_levels" :key="assignment.level"
                                            :value="assignment.level">
                                            {{ assignment.designation }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <li class="job-title">Fora do âmbito da função (classificadas)</li>
                        <div v-for="activity in activitiesToAdd" :key="activity.id">
                            <div class="div-row-activity">
                                <i class="fas show-children cursor-pointer"
                                :class="{ 'fa-chevron-down': !activity.showChildren, 'fa-chevron-up': activity.showChildren }"
                                @click="activity.showChildren = !activity.showChildren"></i>
                                <label for="">{{ activity.designation }}</label>
                                <input class="activity-status cursor-pointer" type="checkbox" v-model="activity.active"
                                @change="ControlActivityStatus(activity)">
                            </div>

                            <div class="div-tasks" v-show="activity.showChildren">
                                <div class="div-task-container div-row-activity" v-for="task in activity.children"
                                    :key="task.id">
                                    <div class="div-task line-clamp line-clamp-1"
                                        @mouseover="Gems.TooltipIfNeeded($event.target)">{{ task.designation }}</div>

                                    <select class="cursor-pointer ddl-alt-padding" :class="!draggable ? 'job-task' : ''"
                                        v-model="task.selected_assignment" @change="SelectTaskAssignment(activity, task)">
                                        <option :value="null"> Não atribuida </option>
                                        <option v-for="assignment in task.assignment_levels" :key="assignment.level" :value="assignment.level">
                                            {{ assignment.designation }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <li class="job-title" @dragenter.prevent @dragover.prevent @drop="SetActivityToUser($event)">Fora do âmbito da função (não classificadas)</li>
                        <div v-for="activity in unratedActivities" :key="activity.id">
                            <div class="div-row-activity">
                                <i class="fas show-children cursor-pointer"
                                :class="{ 'fa-chevron-down': !activity.showChildren, 'fa-chevron-up': activity.showChildren }"
                                @click="activity.showChildren = !activity.showChildren"></i>
                                <label for="">{{ activity.designation }}</label>
                                <i v-if="!draggable" @click="RemoveActivityFromUser(activity)" class="fa fa-times remove-task" :id="`remove-task-${i}`"></i>
                            </div>

                            <div class="div-tasks" v-show="activity.showChildren">
                                <div class="div-task-container div-row-activity" v-for="task in activity.children"
                                    :key="task.id">
                                    <div class="div-task line-clamp line-clamp-1"
                                        @mouseover="Gems.TooltipIfNeeded($event.target)">{{ task.designation }}</div>

                                    <select class="cursor-pointer ddl-alt-padding" :class="!draggable ? 'job-task' : ''"
                                        v-model="task.selected_assignment" @change="SelectTaskAssignment(activity, task)">
                                        <option :value="null"> Não atribuida </option>
                                        <option v-for="assignment in task.assignment_levels" :key="assignment.level" :value="assignment.level">
                                            {{ assignment.designation }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="div-activity-container">
                <div id="div-activity-title">
                    <h2>Atividades (não classificadas)</h2>
                </div>

                <div class="div-column-container scrollbar">
                    <ActivitiesJobRow :activities="activities" :draggable="true" @remove-task="RemoveTask($event)"/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.top,
.bottom {
    overflow-y: visible;
}

.bottom {
    display: flex;
    gap: 10px;
}

#div-subordinates-container,
#div-activity-container {
    width: 100%;
    display: flex;
    flex-direction: column;
}

#div-subordinates-title h2 {
    margin-top: 0px;
}

.job-title {
    font-size: 1.2em;
    font-weight: 600;
}

.div-column-container {
    border: 1px solid;
    height: 100%;
    text-align: left;
    padding: 6px;
}

.div-row-activity,
.div-row {
    padding: 5px 15px;
    cursor: pointer;
    align-items: center;
    border-radius: 25px;
    display: flex;
    gap: 10px;
}

.div-row {
    justify-content: space-between;
}

.div-row:hover,
.div-row-activity:hover {
    background-color: var(--default-app-alt-line-color);
}

.div-row:not(:first-child),
.div-row-activity:not(:first-child) {
    margin-top: 8px;
}

.div-task-container {
    margin: 5px 0px 0px 10px;
}

.div-activity select,
.div-task-container select {
    background-color: var(--default-app-alt-line-color);
}

.div-activity,
.div-task-container {
    height: 25px;
    padding-left: 15px;
    padding-right: 15px;
}
</style>